import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CustomerContact } from 'src/app/classes/customer-contact';
import { CustomerContactCard } from 'src/app/classes/customer-contact-card';
import { SettingsService } from 'src/app/services/settings.service';

@Component({
  selector: 'app-edit-card',
  templateUrl: './edit-card.component.html',
  styleUrls: ['./edit-card.component.scss'],
})
export class EditCardComponent  implements OnInit {
  card = new CustomerContactCard()
  contact = new CustomerContact()

  constructor(public activeModal: NgbActiveModal,
    private settingsService: SettingsService
  ) { }

  ngOnInit() {}

  makeDefault() {
    this.settingsService.setDefaultCard(this.card.id).subscribe(() => {
      this.activeModal.close()
    })
  }

  remove() {
    if(confirm($localize `Are you sure?`)) {
      this.settingsService.removeCard(this.card.id).subscribe(() => {
        alert($localize `Card removed`)
        this.activeModal.close()
      })
    }
  }
}
